"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewDataService = void 0;
const api_1 = require("../api");
class PreviewDataService {
    constructor({ client }) {
        this.apiVersion = api_1.apiVersion;
        this.client = client;
    }
    createPreview(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.client.fetch(`/${this.apiVersion}/sql/preview`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json",
                },
                body: params.data_plane_request,
            })).json();
        });
    }
    getPreview(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.client.fetch(`/${this.apiVersion}/sql/preview`, {
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "decodable-token": params.pagination_token,
                },
            })).json();
        });
    }
}
exports.PreviewDataService = PreviewDataService;
exports.default = PreviewDataService;
